import { LabelProviderBase2D } from 'scichart'

/**
 * Custom label provider for DateTimeNumericAxis that formats timestamps as date + time
 */
export class TimeLabelProvider extends LabelProviderBase2D {
  type = "TimeLabelProvider";
  
  onBeginAxisDraw(): void {
    // Required abstract method - no setup needed for time formatting
  }
  
  constructor(timeZone: 'local' | 'UTC' | string = 'local') {
    super();

    const fmt = new Intl.DateTimeFormat('en-US', {
      // If 'local', let the browser use the user's local timezone by omitting timeZone option
      ...(timeZone !== 'local' ? { timeZone: timeZone === 'UTC' ? 'UTC' : timeZone } : {}),
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });

    const format = (ms: number): string => {
      const parts = fmt.formatToParts(new Date(ms));
      const get = (t: string) => parts.find(p => p.type === t)?.value || '';
      const [MM, DD, YYYY] = [get('month'), get('day'), get('year')];
      const [HH, mm, ss] = [get('hour'), get('minute'), get('second')];
      return `${YYYY}-${MM}-${DD} ${HH}:${mm}:${ss}`;
    };

    this.formatLabel = (dataValue: number): string => format(dataValue);
    this.formatCursorLabel = (dataValue: number): string => format(dataValue);
  }
} 
